import React from 'react';
import StandaloneShell from '../../components/StandaloneShell';
import PermissionGate from '../../components/PermissionGate';
import People from '../People';

export default function PeoplePage() {
  const token = localStorage.getItem('token');
  return (
    <StandaloneShell title="People">
      {({ darkMode, T }) => (
        <PermissionGate module="people" moduleName="People">
          <People token={token} darkMode={darkMode} T={T} />
        </PermissionGate>
      )}
    </StandaloneShell>
  );
}
